/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const labResultFiles = sqliteTable('lab_result_files', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  lab_result_id: text('lab_result_id'),
  patient_file_id: text('patient_file_id'),
  patient_id: text('patient_id'),
  sort_order: integer('sort_order'),
  uploaded_by: text('uploaded_by'),
  uploaded_at: text('uploaded_at'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
